import { cn } from "@/lib/utils";
import Image from "next/image";
import { Button } from "../../button";
import { getBackgroundDuration } from "./CarouselBackgrounds";
import { useHeroCarousel } from "./useHeroCarousel";

export const CarouselThumbnails = () => {
  const { currentIndex, slides, handleSlideChange, handleTimerReset } =
    useHeroCarousel();

  return (
    <div className="flex gap-2 items-center">
      {slides.map((slide, index) => {
        const isActive = index === currentIndex;
        const duration = getBackgroundDuration(slide);

        return (
          <Button
            key={slide.route}
            variant="ghost"
            size="icon"
            onClick={() => {
              handleSlideChange(index);
              handleTimerReset();
            }}
            className={cn(
              "relative overflow-hidden border-2 transition-all duration-300 rounded",
              "h-12 w-16 sm:h-12 sm:w-20 lg:h-16 lg:w-28",
              isActive
                ? "border-white scale-105 shadow-lg"
                : "border-white/30 hover:border-white/60 hover:scale-102",
            )}
          >
            <Image
              src={slide.thumbnailUrl}
              alt={`${slide.route} thumbnail`}
              fill
              sizes="(max-width: 640px) 56px, (max-width: 1024px) 80px, 112px"
              className="object-contain w-full h-full p-1"
            />
            {isActive && (
              <>
                {/* Mobile: Progress bar at bottom */}
                <div
                  className="sm:hidden absolute bottom-0 left-0 h-1 bg-white/90 pointer-events-none"
                  style={{
                    animation: `thumbnail-progress ${duration}ms linear forwards`,
                  }}
                />
                {/* Desktop: Blur sweep effect */}
                <div
                  className="hidden sm:block absolute inset-y-0 left-0 bg-black/10 backdrop-blur-[2px] pointer-events-none"
                  style={{
                    animation: `thumbnail-progress ${duration}ms linear forwards`,
                  }}
                />
              </>
            )}
          </Button>
        );
      })}
    </div>
  );
};
